import { TypographyMuted, TypographyP } from '@talentmesh/ui/components/typography';
import React from 'react';
import UIStrings from '../utils/UIStrings';

interface FooterProps {
    companyName: string;
    websiteUrl: string;
}

function Footer({ companyName, websiteUrl }: FooterProps): React.JSX.Element {
    return (
        <footer className="bg-alicia flex flex-col items-start gap-4 p-4">
            <TypographyP className="text-primary text-sm">{companyName}</TypographyP>
            <p className="text-sm">
                <TypographyMuted>{`${UIStrings.PoweredBy} `}</TypographyMuted>
                <a
                    href={websiteUrl}
                    target="_blank"
                    rel="noreferrer"
                    className="text-primary font-bold no-underline hover:underline"
                >
                    {UIStrings.TalentMesh}
                </a>
            </p>
        </footer>
    );
}

export default Footer;
